import { createContext } from "react";

interface BackgroundContextOptions {
  background: string;
  setBackground: (background: string) => void;
}

export const BackgroundContext = createContext<BackgroundContextOptions>({
  background: "cream-0",
  setBackground: () => null,
});
